import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import merge from 'lodash/merge'

const http = axios.create({
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})
// 返回其他状态吗
http.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500  // 默认的
}
/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  config.headers.Authorization = 'Bearer' + ' ' + Vue.cookie.get('token') // 请求头带上token
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  if (response && response.status === 401) { // 401, token失效
    Vue.cookie.delete('token')
    Vue.prototype.$message({
      type: 'error',
      message: '登录过期，请重新登录!'
    })
    router.options.isAddDynamicMenuRoutes = false
    router.replace({name: 'login'})
  }
  if (response.status !== 200 || response.data.code === 1) {
    Vue.prototype.$message({
      type: 'error',
      message: response.data.msg
    })
  }
  return response
}, error => {
  return Promise.reject(error)
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  return (process.env.NODE_ENV !== 'production' ? '/proxyApi' : '') + actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefaultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefaultParams = true) => {
  const defaults = {
    t: new Date().getTime()
  }
  return openDefaultParams ? merge(defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, openDefaultdata = true, contentType = 'json') => {
  const defaults = {
    t: new Date().getTime()
  }
  data = openDefaultdata ? merge(defaults, data) : data
  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

export default http
